import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatBadgeModule } from '@angular/material/badge';

import {
    DayjsModule,
    DeliveryTimeModule,
    DisplayCurrencyModule,
    HighlightModule,
    StringPreviewModule,
    SupplierDisplayNamePipe,
} from '@lib/util';
import { CopyToClipboardModule } from '@lib/core';
import { UnitModule } from '@lib/unit';
import { AccountingSelectionModule } from '@lib/accounting';
import {
    IimAutocompleteModule,
    IimCardModule,
    IimDatepickerModule,
    IimDecimalInputV2Component,
    IimMultiselectModule,
} from '@iim-angular/components';
import { SharedUnitePipesModule } from '@lib/unite-pipes';
import { BasketOverviewComponent } from './basket-overview/basket-overview.component';
import { BasketOverviewSkeletonComponent } from './basket-overview-skeleton/basket-overview-skeleton.component';
import { BasketCheckComponent } from './basket-check/basket-check.component';
import { BasketCurrencyTotalsComponent } from '@lib/basket/suppliers-basket/ui';
import { BasketSummaryComponent } from './basket-summary/basket-summary.component';
import { BasketFeeComponent } from './basket-fee/basket-fee.component';
import { BasketAddressesComponent } from './basket-addresses/basket-addresses.component';
import { Alpha2CountryCodeModule, CompanyAddressModule } from '@lib/address';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ClientErpTransmissionModule } from '@lib/client';
import { SharedImageUiModule } from '@lib/shared/image/ui';
import { BasketAddressSelectionComponent } from './basket-address-selection/basket-address-selection.component';
import { AddressComponent } from './address/address.component';
import { BasketAddressItemComponent } from './basket-address-item/basket-address-item.component';
import { BasketOrderComponent } from './basket-order/basket-order.component';
import { BasketTaskContainerModule } from '@lib/workflow-integration';
import { TextModuleSelectionComponent } from '@lib/shared/text-module';
import { SuppliersBasketFeatureModule } from '@lib/basket/suppliers-basket/feature';
import { RouterLink } from '@angular/router';
import { BASKET_ADDRESS_DIALOG_COMPONENT } from '@lib/shared/basket-service';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        MatBadgeModule,
        AccountingSelectionModule,
        IimDecimalInputV2Component,
        SharedUnitePipesModule,
        StringPreviewModule,
        CopyToClipboardModule,
        UnitModule,
        CompanyAddressModule,
        FormsModule,
        ReactiveFormsModule,
        HighlightModule,
        IimCardModule,
        // EPROC-11920: Mitarbeitersuche im Ansprechpartner-Modus des Adressdialogs.
        IimAutocompleteModule,
        MatChipsModule,
        MatCheckboxModule,
        IimMultiselectModule,
        ClientErpTransmissionModule,
        SharedImageUiModule,
        IimDatepickerModule,
        DayjsModule,
        DeliveryTimeModule,
        BasketTaskContainerModule,
        Alpha2CountryCodeModule,
        TextModuleSelectionComponent,
        SuppliersBasketFeatureModule,
        BasketCurrencyTotalsComponent,
        SupplierDisplayNamePipe,
        RouterLink,
        BasketOverviewSkeletonComponent,
        DisplayCurrencyModule,
    ],
    declarations: [
        BasketOverviewComponent,
        BasketAddressesComponent,
        BasketCheckComponent,
        BasketSummaryComponent,
        BasketFeeComponent,
        BasketAddressSelectionComponent,
        AddressComponent,
        BasketAddressItemComponent,
        BasketOrderComponent,
    ],
    providers: [
        { provide: BASKET_ADDRESS_DIALOG_COMPONENT, useValue: BasketAddressSelectionComponent },
    ],
    exports: [
        BasketOverviewComponent,
        BasketAddressesComponent,
        BasketCheckComponent,
        BasketSummaryComponent,
        BasketAddressSelectionComponent,
        AddressComponent,
        BasketAddressItemComponent,
        BasketOrderComponent,
    ],
})
export class BasketUiModule {}
